import { useEffect, useState } from "react";
import { User, Phone, MapPin } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { PageHeader } from "@/components/portal/widgets";
import api from "@/lib/api";

export default function SuppliersAdmin() {
  const [suppliers, setSuppliers] = useState([]);
  useEffect(() => { api.get("/admin/suppliers").then((r) => setSuppliers(r.data)).catch(() => {}); }, []);

  return (
    <div className="animate-fade-up">
      <PageHeader title="Suppliers" subtitle={`${suppliers.length} supply partners feeding the network.`} />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {suppliers.map((s) => (
          <Card key={s.id} data-testid={`supplier-card-${s.id}`} className="p-5 border-slate-200/80 dark:border-slate-800">
            <div className="flex items-center justify-between">
              <h3 className="font-heading font-semibold">{s.name}</h3>
              <Badge className="bg-yellow-200 text-yellow-700">{s.category}</Badge>
            </div>
            <p className="text-sm text-muted-foreground flex items-center gap-1 mt-3"><User className="w-3.5 h-3.5" /> {s.contact}</p>
            <p className="text-sm text-muted-foreground flex items-center gap-1 mt-1"><Phone className="w-3.5 h-3.5" /> {s.phone}</p>
            <p className="text-sm text-muted-foreground flex items-center gap-1 mt-1"><MapPin className="w-3.5 h-3.5" /> {s.city}</p>
          </Card>
        ))}
      </div>
    </div>
  );
}
